import {Typography} from '@material-ui/core';
import React from 'react';

import './AdOverlayOnFrame.scss';

export default function AdOverlayOnFrame() {
    return (
        <div className="ad-overlay-on-frame">
            <div className="ad-overlay-on-frame-content">
                <Typography
                    className="ad-overlay-on-frame-label"
                    variant="body1"
                >
                    Ad break
                </Typography>
            </div>
        </div>
    );
}
